import axios from '@/axios'
import Vue from 'vue'
import {SELF_REGISTRATION_NO} from "@/utils/SelfRegistrationTypes";
import {setColor} from "@/utils/Progress";
import {isAndroidApp, isIosApp, isPwa} from "../../utils/Pwa";
import i18n from '@/i18n';
import {isDefaultModuleLocation} from '@/utils/EntityUuid';

const fontColorContrast = require('font-color-contrast');
const hexRgb = require('hex-rgb');

const state = {
  isLoading: true,
  entity: {
    name: null,
    iodoEmail: null,
    clientsExceeded: false,
    businessClientsExceeded: false,
    clientsNumberExceeded: false,
    billingData: {
      type: 0,
      companyName: null,
      nip: null,
      firstName: null,
      lastName: null,
      street: null,
      postCode: null,
      city: null
    }
  },
  title: null,
  mobileApplication: true,
  enabled: "0",
  accountBlocked: false,
  termsPageUuid: null,
  privacyPageUuid: null,
  disableProfileEdit: "0",
  logoUrl: null,
  bgUrl: null,
  colorHex: null,
  colorRGB: null,
  colorContrast: null,
  contactEmail: '',
  myCardEnabled: "0",
  barcodeFormat: null,
  rewardsCatalogSort: 0,
  rewardsOrders: "0",
  rewardsShowVariants: true,
  rewardsOrdersDelivery: {
    shipment: false,
    pickup: false,
    pickupShops: []
  },
  rewardsPerPage: 6,
  rewardsCategoriesAsGrid: 0,
  selfRegistration: 0,
  registration: {
    allowExistingNumbers: false,
  },
  requiredFields: [],
  operationsOpinionsEnabled: "0",
  opinionModal: {
    show: false,
    opinion: null,
    operationId: null
  },
  opinionPremiumActivity: "0",
  additionalFields: [],
  callingCodes: {},
  defaultCallingCode: '',
  clientNumberLabel: "Numer klienta",
  showPointsLocation: false,
  attachments: {
    enabled: false,
    description: '',
    maxFiles: 0,
    hasFreeSpace: false,
    maxFileSize: 0,
  },
  goals: {
    enabled: false,
    name: 'Cele grupowe'
  },
  favicons: null,
  push: {
    enabled: false,
  },
  ranking: {
    enabled: false,
    description: '',
  },
  externalLogin: {
    google: 1,
    facebook: 1,
    apple: 1,
    apple2: 1,
  },
  login: {
    header: '',
    subheader: '',
  },
  analytics: {
    gtm: null,
    ga4: null,
    fbp: null,
    cookiesBanner: true,
  },
  profile: {
    fieldsDescription: {},
    fieldsEnabled: {},
  },
  app:{
    apple:{
      scheme:"https"
    }
  },
  translation: null
};

const actions = {
  fetchSettings({commit, dispatch, rootState}, uuid = null) {
    const uuidUrlPart = uuid ? `/${uuid}` : '';
    return axios.get(`entity/settings${uuidUrlPart}?ios=${isIosApp}&android=${isAndroidApp}&pwa=${isPwa}`)
      .then((r) => {
        if (r.data.success) {
          let lang = r.data.entity.lang;
          let locale = r.data.entity.locale;
          localStorage.setItem('locale', locale);

          try {
              const messages = require('../../../translations/' + lang + '.json');

              i18n.setLocaleMessage(lang, messages);
              i18n.locale = lang
          } catch (e) {
              // Keep default locale messages when tenant translation file is missing.
          }

          if (r.data.hasOwnProperty('agreements')) {
            dispatch('setAgreements', r.data.agreements)
          }

          dispatch('setEntityUuid', r.data.entity.uuid)
          commit('SET_SETTINGS', r.data);

          if (process.env.NODE_ENV === 'production'
            && r.data.settings.domain
            && !window.location.href.includes(r.data.settings.domain)
          ) {
            window.location = r.data.settings.domain;
          }

          let registerParam = new URLSearchParams(location.search).get('register');
          const register = registerParam === '1' || registerParam === '';
          const base = isDefaultModuleLocation() ? '/member/' : '/';
          let getParams = '';

          //remove register param from url
          if (register) {
            getParams = new URLSearchParams(location.search);
            getParams.delete('register');
            getParams = getParams.toString();
          }

          if (register && !rootState.auth.isAuthorized && r.data.settings.self_registration !== SELF_REGISTRATION_NO) {
            dispatch('setSignUpForm');
            window.history.replaceState({}, document.title, `${base}${uuid}/login?${getParams}`);
          }

          if (register && !rootState.auth.isAuthorized && r.data.settings.self_registration === SELF_REGISTRATION_NO) {
            dispatch('setSetPasswordForm');
            window.history.replaceState({}, document.title, `${base}${uuid}/login?${getParams}`);
          }

        } else {
          window.location = 'https://loyaltystarter.io';
        }
      })
  },
  setDisabled({commit}) {
    commit('SET_DISABLED')
  },
  showOpinionModal({commit}, payload) {
    commit('SHOW_OPINION_MODAL', payload)
  },
  closeOpinionModal({commit}) {
    commit('CLOSE_OPINION_MODAL')
  }
};

const mutations = {
  SET_SETTINGS(state, data) {
    state.title = data.settings.module_name;
    state.entity.name = data.entity.entity_name;
    state.entity.iodoEmail = data.entity.iodo_email;
    state.entity.locale = data.entity.locale;
    state.entity.clientsExceeded = data.entity.clients_exceeded;
    state.entity.businessClientsExceeded = data.entity.business_clients_exceeded;
    state.entity.clientsNumberExceeded = data.entity.clients_numbers_exceeded;
    state.enabled = data.settings.enabled;
    state.accountBlocked = data.settings.account_blocked;
    state.termsPageUuid = data.settings.terms_page_uuid;
    state.privacyPageUuid = data.settings.privacy_page_uuid;
    state.disableProfileEdit = data.settings.disable_profile_edit;
    state.logoUrl = data.settings.logo_img_url;
    state.bgUrl = data.settings.bg_img_url;
    setBackgroundProperty(state.bgUrl);
    state.contactEmail = data.settings.contact_email;
    state.myCardEnabled = data.settings.my_card_enabled;
    state.barcodeFormat = data.settings.barcode_format;
    state.rewardsCatalogSort = parseInt(data.settings.rewards_catalog_sort, 10);
    state.rewardsOrders = data.settings.rewards_orders;
    state.rewardsPerPage = data.settings.rewards_per_page;
    state.rewardsCategoriesAsGrid = data.settings.rewards_categories_as_grid;
    state.selfRegistration = data.settings.self_registration;
    state.operationsOpinionsEnabled = data.settings.operations_opinions_enabled;
    state.opinionPremiumActivity = data.settings.opinion_premium_activity;
    state.showPointsLocation = data.settings.show_points_location;
    state.colorHex = data.settings.color_hex;
    state.app.apple.scheme = data.settings.app.apple.scheme;
    state.points = data.settings.points;
    state.mobileApplication = data.settings.mobile_application;

    if (data.settings.color_hex) {
      setColor(data.settings.color_hex); //progress bar
      state.colorRGB = hexRgb(data.settings.color_hex);
      state.colorContrast = fontColorContrast(data.settings.color_hex);
    }

    setColors(data.settings.color_hex);
    state.clientNumberLabel = 'Numer klienta';

    if (data.settings.client_number_label && data.settings.client_number_label.length) {
      state.clientNumberLabel = data.settings.client_number_label;
    }

    Vue.set(state, 'attachments', data.settings.attachments);
    Vue.set(state, 'push', data.settings.push);
    Vue.set(state, 'ranking', data.settings.ranking);
    Vue.set(state, 'requiredFields', data.settings.required_fields);
    Vue.set(state, 'additionalFields', data.settings.additional_fields);
    Vue.set(state, 'callingCodes', data.callingCodes);
    Vue.set(state, 'defaultCallingCode', data.defaultCallingCode);
    Vue.set(state, 'externalLogin', data.settings.external_login);
    Vue.set(state, 'login', data.settings.login);
    Vue.set(state, 'rewardsOrdersDelivery', data.settings.rewards_orders_delivery);
    Vue.set(state, 'rewardsShowVariants', data.settings.rewards_show_variants);
    Vue.set(state, 'registration', data.settings.registration);

    let billing = {
      type: data.entity.billing_data.type,
      companyName: data.entity.billing_data.company_name,
      nip: data.entity.billing_data.nip,
      firstName: data.entity.billing_data.first_name,
      lastName: data.entity.billing_data.last_name,
      street: data.entity.billing_data.street,
      postCode: data.entity.billing_data.post_code,
      city: data.entity.billing_data.city
    };

    Vue.set(state.entity, 'billingData', billing);

    if (state.title) {
      const Entities = require('html-entities').XmlEntities;
      const entities = new Entities();

      document.title = entities.decode(state.title) ;
    }

    Vue.set(state, 'favicons', null);

    if (data.settings.hasOwnProperty('favicons') && data.settings.favicons !== null) {
      let favicons = data.settings.favicons;

      document.querySelector('link[rel="icon"][sizes="32x32"]').href = favicons['40'];
      document.querySelector('link[rel="icon"][sizes="16x16"]').href = favicons['40'];
      document.querySelector('link[rel="apple-touch-icon"]').href = favicons['180'];
      document.querySelector('meta[name="msapplication-TileImage"]').content = favicons['310'];

      Vue.set(state, 'favicons', favicons)
    }

    if (process.env.NODE_ENV === 'production' && data.settings.logo_img_url) {
      caches.open('offline-mk').then((cache) => cache.add(data.settings.logo_img_url))
    }

    Vue.set(state, 'analytics', data.settings.analytics);
    Vue.set(state, 'profile', data.settings.profile);
    Vue.set(state, 'translations', data.translation);

    state.isLoading = false;
  },
  SET_DISABLED(state) {
    state.enabled = "0"
  },
  SHOW_OPINION_MODAL(state, payload) {
    Vue.set(state, 'opinionModal', {
      show: true,
      opinion: payload.opinion,
      operationId: payload.operationId
    })
  },
  CLOSE_OPINION_MODAL(state) {
    Vue.set(state, 'opinionModal', {
      show: false,
      opinion: null,
      operationId: null
    })
  }
};

export function setViewSettings(settings) {
  setBackgroundProperty(settings.bgUrl);
  setColors(settings.colorHex)
}

function setBackgroundProperty(bgUrl) {
  let bodyStyles = document.body.style;
  if (bgUrl) {
    bodyStyles.setProperty('--bg-image', `url(${bgUrl}) fixed`);
  }else{
    let style = getComputedStyle(document.body)
    bodyStyles.setProperty('--bg-image', style.getPropertyValue('--bg-image-default'));
  }
}

function setColors(bgHex) {
  if (bgHex) {
    let bodyStyles = document.body.style;

    const rgba = hexRgb(bgHex);

    bodyStyles.setProperty('--accent-color', bgHex);
    bodyStyles.setProperty('--btn-color', fontColorContrast(bgHex));
    bodyStyles.setProperty('--btn-box-shadow-color', `rgba(${rgba.red}, ${rgba.green}, ${rgba.blue}, 0.36)`);
    bodyStyles.setProperty('--btn-bg-rgba', `rgba(${rgba.red}, ${rgba.green}, ${rgba.blue}, 1)`);
    bodyStyles.setProperty('--btn-bg-darker', `rgba(${rgba.red * 0.9}, ${rgba.green * 0.9}, ${rgba.blue * 0.9}, 1)`);
  }
}

const getters = {
  getField: state => (key) => state.additionalFields.find(field => field.key === key),
};

export default {
  state,
  actions,
  mutations,
  getters
}
